import { FoodCard } from "components";
import { useState } from "react";

function FoodBeverage({ setActiveStep }) {
  const tabs = [
    {
      label: "Food",
      value: "food",
    },
    {
      label: "Beverages",
      value: "beverages",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].value);

  const foods = [
    {
      label: "Paneer Tikka Rice Bowl - Mini",
      price: 20,
      image: "/images/food-1.png",
    },
    {
      label: "Aloo Paratha Curd Meal (2 pcs)",
      price: 10,
      image: "/images/food-2.png",
    },
    {
      label: "Paneer Tikka Rice Bowl - Mini",
      price: 20,
      image: "/images/food-1.png",
    },
    {
      label: "Aloo Paratha Curd Meal (2 pcs)",
      price: 10,
      image: "/images/food-2.png",
    },
    {
      label: "Mixed Veg Fried Rice with dry fruit",
      price: 20,
      image: "/images/food-3.png",
    },
    {
      label: "Aloo Paratha Curd Meal (5 pcs)",
      price: 20,
      image: "/images/food-2.png",
    },
    {
      label: "Mixed Veg Fried Rice with dry fruit",
      price: 20,
      image: "/images/food-3.png",
    },
    {
      label: "Aloo Paratha Curd Meal (5 pcs)",
      price: 20,
      image: "/images/food-2.png",
    },
  ];

  return (
    <div className="w-full bg-white shadow-cityCard py-6 px-6">
      <div className="w-full flex items-center mb-6">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`text-base text-black font-medium py-3 px-4 border-b-[1px] border-[#112211]/25 animation ${
              tab.value === activeTab
                ? "text-primary-700 font-semibold border-primary-700"
                : ""
            }`}
            onClick={() => setActiveTab(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-8 mb-6 md:mb-8">
        {foods.map((item, index) => (
          <FoodCard key={index} data={item} />
        ))}
      </div>
      <button
        onClick={() => setActiveStep(3)}
        className="w-full h-[48px] px-4 py-3 bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white"
      >
        Continue
      </button>
    </div>
  );
}

export default FoodBeverage;
